module.exports = __webpack_public_path__ + "img/hardwareOpen2.4af29270.png";